"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var ksys_app_template_1 = require("@kurtosys/ksys-app-template");
if (customElements.get('ksys-event-bus') === undefined) {
  var KsysEventBus = /** @class */function (_super) {
    __extends(KsysEventBus, _super);
    function KsysEventBus() {
      var _this = _super.call(this) || this;
      _this.attachShadow({
        mode: 'open'
      });
      return _this;
    }
    return KsysEventBus;
  }(HTMLElement);
  customElements.define('ksys-event-bus', KsysEventBus);
}
var EventBus = /** @class */function () {
  function EventBus() {}
  EventBus.triggerUpdatePagination = function (eventDetail) {
    EventBus.helper.trigger('ksys-update-pagination', {
      detail: eventDetail
    });
  };
  EventBus.registerUpdatePagination = function (appKey, callback) {
    EventBus.registerEvent('ksys-update-pagination', appKey, callback);
  };
  EventBus.triggerPaginationOnChange = function (eventDetail) {
    EventBus.helper.trigger('ksys-pagination-on-change', {
      detail: eventDetail
    });
  };
  EventBus.registerPaginationOnChange = function (appKey, callback) {
    EventBus.registerEvent('ksys-pagination-on-change', appKey, callback);
  };
  EventBus.registerEvent = function (eventKey, appIdentifier, callback) {
    var _this = this;
    EventBus.helper.register(eventKey, {
      handleEvent: function handleEvent(customEvent) {
        return __awaiter(_this, void 0, void 0, function () {
          var _a, identifier;
          return __generator(this, function (_b) {
            _a = customEvent.detail.identifier, identifier = _a === void 0 ? '' : _a;
            if (appIdentifier === identifier) {
              callback(customEvent.detail);
            }
            return [2 /*return*/];
          });
        });
      }
    });
  };

  EventBus.helper = new ksys_app_template_1.helpers.EventBusHelper();
  return EventBus;
}();
exports.EventBus = EventBus;